import styled from '@emotion/styled'
import { Typography } from '@mui/material'
import { FC } from 'react'
import { Colors, Shapes } from 'src/components/theme'
import { CardCvcElement, CardExpiryElement, CardNumberElement } from '@stripe/react-stripe-js'
import { Flex } from 'src/components/flex-containers'
import {
  StripeCardCvcElementOptions,
  StripeCardExpiryElementOptions,
  StripeCardNumberElementOptions,
} from '@stripe/stripe-js'

const StyledForm = styled.form`
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: ${Shapes.spacing[4]}px;
`

const FormContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Shapes.spacing[2]}px;
`

const InputWrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: ${Shapes.spacing[1]}px;
  div {
    border: 1px solid ${Colors.border};
    border-radius: ${Shapes.borderRadius}px;
    padding: ${Shapes.spacing[2]}px;
  }
`
const basicStyle = {
  base: {
    backgroundColor: `${Colors.bgWhite}`,
    color: `${Colors.textMedium}`,
    fontSize: '14px',
    fontFamily: 'SofiaPro-Medium, Helvetica, sans-serif',
    '::placeholder': {
      color: `${Colors.textLight}`,
    },
  },
  invalid: {
    color: `${Colors.redDark}`,
    iconColor: `${Colors.redDark}`,
  },
  complete: {
    color: `${Colors.blueDark}`,
    iconColor: `${Colors.blueDark}`,
  },
}

const cardNumberOptions: StripeCardNumberElementOptions = {
  style: basicStyle,
  showIcon: true,
  placeholder: '1234 1234 1234 1234',
}
const cardCVCOptions: StripeCardCvcElementOptions = {
  style: basicStyle,
  placeholder: '123',
}
const cardExpiryOptions: StripeCardExpiryElementOptions = {
  style: basicStyle,
  placeholder: 'mm / yy',
}

type CreditCardFormProps = {
  onSubmit?: (e: React.SyntheticEvent<HTMLFormElement>) => void
  bottomContent?: React.ReactNode
  topContent?: React.ReactNode
}

export const CreditCardForm: FC<CreditCardFormProps> = ({ onSubmit, bottomContent, topContent }) => {
  const handleSubmit = async (e: React.SyntheticEvent<HTMLFormElement>) => {
    e.preventDefault()
    onSubmit?.(e)
  }

  return (
    <StyledForm id="payment-form" onSubmit={handleSubmit}>
      {topContent}
      <FormContent>
        <InputWrapper>
          <Typography variant="text1" color={Colors.textDark}>
            Card Number
          </Typography>
          <CardNumberElement options={cardNumberOptions} />
        </InputWrapper>
        <Flex gap={Shapes.spacing[2]}>
          <InputWrapper>
            <Typography variant="text1" color={Colors.textDark}>
              Expiry
            </Typography>
            <CardExpiryElement options={cardExpiryOptions} />
          </InputWrapper>
          <InputWrapper>
            <Typography variant="text1" color={Colors.textDark}>
              CVC
            </Typography>
            <CardCvcElement options={cardCVCOptions} />
          </InputWrapper>
        </Flex>
      </FormContent>
      {bottomContent}
    </StyledForm>
  )
}
